import D2C_ProviderStorage from './Storage'

class D2C_ProviderHubic extends D2C_ProviderStorage {
  static objectType = 'providerType'
  static active = true
  static order = 36
  static providerType = 'Hubic'
  static providerTitle = 'Hubic'
  static oauth = true
  static fields = {
    ...D2C_ProviderStorage.fields,
    apiToken: {
      default: '',
      hidden: true,
      label: 'Token',
      path: 'auth.apiToken',
      required: true,
      validate(value) {
        return (value && value.length > 0) ? null : 'Must be filled'
      },
      creating: {},
    },
    refreshToken: {
      default: '',
      hidden: true,
      label: 'Refresh Token',
      path: 'auth.refreshToken',
      required: true,
      validate(value) {
        return (value && value.length > 0) ? null : 'Must be filled'
      },
      creating: {},
    },
  }
}

export default D2C_ProviderHubic
